import type { ListDataParams } from '../types';

export type PipelineListQueryParams = {
  listData: ListDataParams;
  searchTerm?: string;
  version?: string;
};

export type PipelineMissionsQueryParams = {
  pipelineId: number;
  listData: ListDataParams;
};

export type PipelineStageTasksQueryParams = {
  stageId: number;
  page?: number;
  filters?: Record<string, unknown>;
};

export type PipelineOverviewQueryParams = {
  businessUnitId?: number;
  pipelineIds?: number[];
};

export type PipelineOptionsQueryParams = {
  version?: string;
  businessUnitId?: number;
  pipelineType?: 'REVENUE';
};

export type PipelineLeaderboardQueryParams = {
  period: string;
};

export const pipelineQueryKeys = {
  all: ['pipeline'] as const,
  allActive: (version?: string) =>
    [...pipelineQueryKeys.all, 'allActive', version] as const,
  lists: () => [...pipelineQueryKeys.all, 'list'] as const,
  list: (params: PipelineListQueryParams) =>
    [...pipelineQueryKeys.lists(), params] as const,
  details: () => [...pipelineQueryKeys.all, 'detail'] as const,
  detail: (id: number) => [...pipelineQueryKeys.details(), id] as const,
  stages: (id: number, version?: string) =>
    [...pipelineQueryKeys.all, 'stages', id, version] as const,
  stageTasks: (params: PipelineStageTasksQueryParams) =>
    [...pipelineQueryKeys.all, 'stageTasks', params] as const,
  pipelineTasks: (id: number) =>
    [...pipelineQueryKeys.all, 'pipelineTasks', id] as const,
  myPipelines: () => [...pipelineQueryKeys.all, 'myPipelines'] as const,
  myWorkstreams: () => [...pipelineQueryKeys.all, 'myWorkstreams'] as const,
  contractStages: () => [...pipelineQueryKeys.all, 'contractStages'] as const,
  targetTracking: (id: number, userIds?: number[]) =>
    [...pipelineQueryKeys.all, 'targetTracking', id, userIds] as const,
  myTargetTracking: (id: number) =>
    [...pipelineQueryKeys.all, 'myTargetTracking', id] as const,
  missions: (params: PipelineMissionsQueryParams) =>
    [...pipelineQueryKeys.all, 'missions', params] as const,
  dataPoints: (businessUnitId?: number, status?: number) =>
    [...pipelineQueryKeys.all, 'dataPoints', businessUnitId, status] as const,
  overview: (params: PipelineOverviewQueryParams = {}) =>
    [
      ...pipelineQueryKeys.all,
      'overview',
      params.businessUnitId,
      params.pipelineIds
    ] as const,
  options: (params: PipelineOptionsQueryParams = {}) =>
    [
      ...pipelineQueryKeys.all,
      'options',
      params.version,
      params.businessUnitId,
      params.pipelineType
    ] as const,
  leaderboard: (period: string) =>
    [...pipelineQueryKeys.all, 'leaderboard', period] as const
};
